import moment from 'moment'
import { getByteLen } from '@/common/js/utils'
import { PLATFORM } from '@/common/js/constants.js'

/**
 * @description: 创意表单校验
 * @return {*}
 */
export function getCreativeFormRules() {
  return {
    dynamic_creative_name: [
      {
        required: true,
        validator(rule, value, callback) {
          if (!value) return callback(new Error('请填写创意名称'))
          if (Math.ceil(getByteLen(value)) > 90) return callback(new Error('创意名称长度超出限制'))
          callback()
        }
      }
    ]
  }
}
